export default [
  {
    path: "/invoices",
    name: "invoices",
    component: () => import("@/views/pages/invoices/Invoices.vue"),
    meta: {
      hasPermission: true,
      // pageTitle: "لیست پرسش و پاسخ",
      // breadcrumb: [
      //   {
      //     text: "لیست پرسش و پاسخ",
      //     active: true,
      //   },
      // ],
    },
  },
  {
    path: "/invoices/:id",
    name: "show-invoice",
    component: () => import("@/views/pages/invoices/ShowInvoice.vue"),
    meta: {
      // pageTitle: "جزئیات جلسه",
      // breadcrumb: [
      //   {
      //     text: "دوره ها",
      //     to: "/courses",
      //   },
      //   {
      //     hasId: true,
      //     text: "جزئیات جلسه",
      //     active: true,
      //   },
      // ],
    },
  },
  // {
  //   path: "/faqs/add",
  //   name: "add-faq",
  //   component: () => import("@/views/pages/faqs/faq-form/FaqForm.vue"),
  //   meta: {
  //     hasPermission:true,
  //     pageTitle: "اضافه کردن پرسش و پاسخ",
  //     breadcrumb: [
  //       {
  //         text: "لیست پرسش و پاسخ",
  //         to: "/faqs",
  //       },
  //       {
  //         text: "اضافه کردن پرسش و پاسخ",
  //         active: true,
  //       },
  //     ],
  //   },
  // },
  // {
  //     path: "/faqs/:id/edit",
  //     name: "edit-faq",
  //     component: () => import("@/views/pages/faqs/faq-form/FaqForm.vue"),
  //     meta: {
  //       hasPermission:true,
  //       pageTitle: "ویرایش کردن پرسش و پاسخ",
  //       breadcrumb: [
  //         {
  //           text: "لیست پرسش و پاسخ",
  //           to: "/faqs",
  //         },
  //         {
  //           text: "ویرایش کردن پرسش و پاسخ",
  //           active: true,
  //         },
  //       ],
  //     },
  //   },
];
